// Catalog identifiers differ from browser and TradingView language codes.
// This bundled TradingView version does not include every application locale.
function chartLocale(locale) {
    const code = ({ jp: 'ja', kr: 'ko', cz: 'cs' })[locale] || locale;
    return ['en', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'ru', 'tr'].includes(code) ? code : 'en';
}

function selectLanguage(messages) {
    return {
        search: () => messages.select_search,
        removeItem: () => messages.select_remove_item,
        removeAllItems: () => messages.select_remove_all_items,
        noResults: () => messages.select_no_results,
        searching: () => messages.select_searching,
        loadingMore: () => messages.select_loading_more,
        errorLoading: () => messages.select_error_loading,
        inputTooShort: () => messages.select_input_too_short,
        inputTooLong: () => messages.select_input_too_long,
        maximumSelected: () => messages.select_maximum_selected,
    };
}

function configure($, messages) {
    $.fn.select2.defaults.set('language', selectLanguage(messages));
    $.extend(true, $.magnificPopup.defaults, {
        tClose: messages.popup_close,
        tLoading: messages.popup_loading,
        image: { tError: '<a href="%url%">' + messages.popup_image_error + '</a>' },
        ajax: { tError: '<a href="%url%">' + messages.popup_content_error + '</a>' },
        gallery: {
            tPrev: messages.popup_previous,
            tNext: messages.popup_next,
            tCounter: messages.popup_counter,
        },
    });
}

function showChartMaintenance($, messages) {
    const $notice = $('<div class="b-maintanence"><img src="/img/maintanence.svg" alt=""><span></span><p></p></div>');
    $notice.find('span').text(messages.chart_maintenance_title);
    $notice.find('p').text(messages.chart_maintenance_message);
    $('#chartContainer').empty().append($notice);
    $('.j-chart').addClass('j-loaded');
}

module.exports = { chartLocale, selectLanguage, configure, showChartMaintenance };
